import { Form, Input } from "antd";
import { useSelector, useDispatch } from "react-redux";
import styles from "./style.module.scss";
import settingsActions from "../../../../redux/settings/actions";
import "./antCustomStyle.scss";

const Details = () => {
  const dispatch = useDispatch()
  const { currentUser } = useSelector((state) => ({
    currentUser: state.profile.currentUser,
  }));
  const onFinish = (values) => {
    dispatch({
      type: settingsActions.UPDATE_USER_INFOS,
      payload: values,
    })
  };

  return (
    <div className={styles.detailsContainer}>
      <Form name="about-you-form" initialValues={{...currentUser}} onFinish={onFinish} requiredMark={false}>
        <div className={styles.genericButton}>
          <button className={styles.button} htmlType="submit">
            Save
          </button>
        </div>
        <div className={styles.mainContent}>
          <Form.Item label="Username" name={"username"} className={styles.username} hasFeedback>
            <Input prefix={<span className={"username"}>@</span>} />
          </Form.Item>
          <Form.Item label="First Name" name={"firstName"} className={styles.username}>
            <Input prefix={<span className={"username"}>@</span>} />
          </Form.Item>
          <Form.Item label="Last Name" name={"lastName"} className={styles.username}>
            <Input prefix={<span className={"username"}>@</span>} />
          </Form.Item>
          <Form.Item label="Email Address" name={"email"} className={styles.username}>
            <Input prefix={<span className={"username"}>@</span>} />
          </Form.Item>
        </div>
      </Form>
    </div>
  );
};

export default Details;
